import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={26} height={26} rx={6} fill="#352A1F" />
    <path
      d="M16.5039 18.8862V9.07476L20.745 8.19793V18.0093L16.5039 18.8862Z"
      stroke="#A5885D"
    />
    <path
      d="M11.2852 17.0067V7.26694L15.1954 8.99124V18.7325L11.2852 17.0067Z"
      stroke="#A5885D"
    />
    <path
      d="M5.5 17.8067V7.99344L9.91596 7.10994V16.9227L5.5 17.8067Z"
      stroke="#A5885D"
    />
  </svg>
);
export default SVGComponent;
